import { useEffect } from 'react';

/**
 * Component to hide the Emergent badge injected by the platform
 */
const HideBadge = () => {
  useEffect(() => {
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) {
        badge.style.display = 'none';
        badge.style.visibility = 'hidden';
        badge.style.opacity = '0';
        badge.remove();
      }
    };

    // Run immediately
    removeBadge();

    // Set up mutation observer
    const observer = new MutationObserver(() => {
      removeBadge();
    });

    // Observe body for changes
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    // Run periodically as backup
    const interval = setInterval(removeBadge, 300);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  return null;
};

export default HideBadge;
